/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import Promise from 'bluebird';
import _ from 'underscore';

import customError from '@atlassian/trello-error-ext';
import { Analytics } from '@trello/atlassian-analytics';
import { UpgradeSmartComponent } from '@trello/billing/upgrade-prompts';
import { dontUpsell } from '@trello/browser';
import { renderComponent } from '@trello/component-wrapper';
import {
  boxClientId,
  dropboxClientAppKey,
  oneDriveClientId,
  siteDomain,
} from '@trello/config';
import { loadScript } from '@trello/dom';
import { ApiError } from '@trello/error-handling';
import { forTemplate } from '@trello/i18n';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { isSubmitEvent } from '@trello/keybindings';
import { showFlag } from '@trello/nachos/experimental-flags';
import { ExternalLinkIcon } from '@trello/nachos/icons/external-link';
import { TacoIcon } from '@trello/nachos/icons/taco';

import { Auth } from 'app/scripts/db/Auth';
import { GoogleApi } from 'app/scripts/lib/google-api';
import { isOverLimit } from 'app/scripts/lib/limits';
import { l } from 'app/scripts/lib/localize';
import { Util } from 'app/scripts/lib/util';
import { ninvoke } from 'app/scripts/lib/util/ninvoke';
import { parseTrelloUrl } from 'app/scripts/lib/util/url/parse-trello-url';
import { Board } from 'app/scripts/models/Board';
import { Card } from 'app/scripts/models/Card';
import { AttachmentLimitExceededError as LimitExceeded } from 'app/scripts/views/attachment/AttachmentLimitExceededError';
import { AttachmentTypeRestrictedError as TypeRestricted } from 'app/scripts/views/attachment/AttachmentTypeRestrictedError';
import { UploadingLinkView } from 'app/scripts/views/card/UploadingLinkView';
import { TrelloCompleterView } from 'app/scripts/views/internal/autocomplete/TrelloCompleterView';
import { pastedFileName } from 'app/scripts/views/internal/pastedFileName';
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
import { View } from 'app/scripts/views/internal/View';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { Tooltip } from 'app/scripts/views/lib/Tooltip';
import { PopoverLimitExceededTemplate } from 'app/scripts/views/templates/PopoverLimitExceededTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

const t = teacupWithHelpers('attachment_type_picker');
const format = forTemplate('popup_blocked');

/* eslint-disable-next-line @trello/no-module-logic */
const FileTooLarge = customError('AttachmentTypePickerView::FileTooLarge');

// eslint-disable-next-line @trello/no-module-logic
const template = t.renderable(function ({
  hasLargeAttachments,
  hasOrganizationData,
  id,
  googleDriveReady,
  tipKey,
  tipData,
  defaultName,
  restrictedAttachmentTypes,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  if (tipKey == null) {
    tipKey =
      'tip-you-can-drag-and-drop-files-and-links-onto-cards-to-upload-them';
  }
  if (tipData == null) {
    tipData = {};
  }

  t.div(
    '.error.js-file-too-large',
    { style: 'margin: 12px 0 6px; display:none;' },
    function () {
      if (hasLargeAttachments) {
        t.format('that-file-size-exceeds-the-250mb-limit');
      } else if (!hasOrganizationData) {
        t.format('that-file-size-exceeds-the-10mb-limit');
      } else {
        t.div('.attachment-size-limit-upgrade-prompt');
      }
    },
  );

  t.ul('.pop-over-list', function () {
    if (Array.from(restrictedAttachmentTypes).includes('computer')) {
      t.li(() =>
        t.a('.disabled.js-attachment-restricted', { href: '#' }, () =>
          t.format('computer'),
        ),
      );
    } else {
      t.li('.uploader', function () {
        t.a('.fakefile', { href: '#' }, () => t.format('computer'));
        return t.form(
          '.realfile',
          {
            action: `/1/card/${id}/attachments`,
            method: 'post',
            enctype: 'multipart/form-data',
          },
          function () {
            t.input({ type: 'hidden', name: 'dsc', value: '' });
            t.input({ type: 'hidden', name: 'token', value: '' });
            t.input({ type: 'hidden', name: 'format', value: 'http' });
            return t.input('.js-attach-file', {
              type: 'file',
              name: 'file',
              tabindex: '-1',
              multiple: 'multiple',
            });
          },
        );
      });
    }

    t.li(function () {
      t.a('.js-attach-card', { href: '#' }, () => t.format('trello'));

      t.li(() =>
        t.a(
          '.js-google-drive-attachment',
          {
            href: '#',
            class: t.classify({
              disabled:
                !googleDriveReady ||
                Array.from(restrictedAttachmentTypes).includes('google-drive'),
              'js-attachment-restricted': Array.from(
                restrictedAttachmentTypes,
              ).includes('google-drive'),
            }),
          },
          () => t.format('google-drive'),
        ),
      );

      t.li(() =>
        t.a(
          '.js-dropbox-attachment',
          {
            href: '#',
            class: t.classify({
              'disabled js-attachment-restricted': Array.from(
                restrictedAttachmentTypes,
              ).includes('dropbox'),
            }),
          },
          () => t.format('dropbox'),
        ),
      );

      t.li(() =>
        t.a(
          '.js-box-attachment',
          {
            href: '#',
            class: t.classify({
              'disabled js-attachment-restricted': Array.from(
                restrictedAttachmentTypes,
              ).includes('box'),
            }),
          },
          () => t.format('box'),
        ),
      );

      return t.li(() =>
        t.a(
          '.js-one-drive-attachment',
          {
            href: '#',
            class: t.classify({
              'disabled js-attachment-restricted': Array.from(
                restrictedAttachmentTypes,
              ).includes('onedrive'),
            }),
          },
          () => t.format('onedrive'),
        ),
      );
    });
  });

  t.hr();

  if (Array.from(restrictedAttachmentTypes).includes('link')) {
    t.ul('.pop-over-list', () =>
      t.li(() =>
        t.a('.disabled.js-attachment-restricted', () =>
          t.format('attach-a-link'),
        ),
      ),
    );
  } else {
    t.label({ for: 'addLink' }, function () {
      t.format('attach-a-link');
    });

    t.input('.attachment-add-link-input.js-attachment-url.js-autofocus', {
      type: 'text',
      id: 'addLink',
      placeholder: t.l('paste-any-link-here-ellipsis'),
    });

    t.div('.js-name-link.hide', function () {
      t.label({ for: 'nameLink' }, function () {
        t.format('link-name');
      });

      return t.input('.attachment-add-link-input.js-attachment-name', {
        type: 'text',
        id: 'nameLink',
        value: defaultName,
      });
    });

    t.input('.js-add-attachment-url', {
      style: 'margin: 0;',
      type: 'submit',
      value: t.l('attach'),
    });
  }

  t.hr();

  t.p('.quiet.u-bottom', function () {
    t.format(tipKey, tipData);
  });
});

interface AttachmentTypePickerView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _scripts: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unmountAttachmentUpgradePrompt: any;
}

class AttachmentTypePickerView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'attach from';

    this.prototype.events = {
      // @ts-expect-error TS(2322): Type '{ 'click .js-google-drive-attachment:not(.di... Remove this comment to see the full error message
      'click .js-google-drive-attachment:not(.disabled)':
        'openGoogleDriveFilePicker',
      'click .js-dropbox-attachment:not(.disabled)': 'openDropboxFilePicker',
      'click .js-one-drive-attachment:not(.disabled)': 'openOneDriveFilePicker',
      'click .js-box-attachment:not(.disabled)': 'openBoxFilePicker',
      'click .js-attach-card': 'attachCard',
      'change .js-attach-file': 'startUpload',
      'click .js-add-attachment-url': 'addUrl',
      'keydown .js-attachment-url': 'keydown',
      'keydown .js-attachment-name': 'keydown',
      'input .js-attachment-url': 'toggleAttachmentNameInput',
      'mouseenter .js-attachment-restricted': 'showRestrictedTooltip',
      'mouseleave .js-attachment-restricted': 'hideRestrictedTooltip',
      'click a[href^="/business-class"]'() {
        return Analytics.sendClickedLinkEvent({
          linkName: 'businessClassLink',
          source: 'cardAttachmentPickerInlineDialog',
        });
      },
    };

    this.prototype._scripts = {
      dropbox: 'https://www.dropbox.com/static/api/1/dropbox.js',
      box: 'https://app.box.com/js/static/select.js',
      oneDrive: 'https://js.live.net/v7.0/OneDrive.js',
    };
  }

  initialize() {
    GoogleApi.ensureApiLoaded();
    return this.listenTo(GoogleApi, 'loaded', this.render);
  }

  getCard() {
    if (this.model instanceof Card) {
      return this.model;
    } else {
      return this.model.getCard();
    }
  }

  getData() {
    // We're trying to delay loading these scripts, to reduce the chance that
    // they'll cause problems on the client; unfortunately we need to load them
    // prior to the user trying to upload a file from that service, otherwise
    // any popup windows they try to open will be blocked (i.e. if we try to
    // asynchronously load a script between the time they click and when we start
    // the associated picker)
    for (const key in this._scripts) {
      const scriptUrl = this._scripts[key];
      this._loadOnce(scriptUrl, function () {});
    }
  }

  render() {
    const card = this.getCard();
    const board = card?.getBoard();
    if (!card?.canAttach()) {
      if (isOverLimit('attachments', 'perCard', card?.get('limits'))) {
        this.$el.html(PopoverLimitExceededTemplate('perCard'));
      } else if (isOverLimit('attachments', 'perBoard', board?.get('limits'))) {
        this.$el.html(PopoverLimitExceededTemplate('perBoard'));
      }
      return this;
    }

    const data = {
      id: card?.id,
      hasLargeAttachments: board?.isFeatureEnabled('largeAttachments') || false,
      hasOrganizationData: Boolean(board?.getOrganization()),
      googleDriveReady: GoogleApi.loaded,
      defaultName: this.options.defaultName,
      restrictedAttachmentTypes: board?.getRestrictedAttachmentTypes() || [],
    };

    this.$el.html(template(data));

    const container = this.el.querySelector(
      '.attachment-size-limit-upgrade-prompt',
    );
    this.unmountAttachmentUpgradePrompt = container
      ? renderComponent(
          <UpgradeSmartComponent
            orgId={board?.get('idOrganization')}
            promptId="attachmentSizeLimitUpgradePromptFull"
            allowUpsell={!dontUpsell()}
          />,
          container,
        )
      : undefined;

    return this;
  }

  remove() {
    this.unmountAttachmentUpgradePrompt?.();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  startUpload(e: any) {
    const $input = $(e.target);

    const $tooLarge = $('.js-file-too-large', this.$el).hide();
    const files = _.toArray($input[0].files);
    const { options } = this;

    Analytics.sendClickedLinkEvent({
      linkName: 'attachFromComputerLink',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });
    const source = 'cardAttachmentPickerInlineDialog';
    const analyticsPayload = {
      source,
      taskName: 'create-attachment/file',
    };
    // @ts-expect-error TS(2345): Argument of type '{ source: string; taskName: stri... Remove this comment to see the full error message
    const traceId = Analytics.startTask(analyticsPayload);
    // @ts-expect-error TS(2339): Property 'traceId' does not exist on type '{ sourc... Remove this comment to see the full error message
    analyticsPayload.traceId = traceId;

    if (options.onStartUpload) {
      // @ts-expect-error TS(2339): Property 'onStartUpload' does not exist on type '{... Remove this comment to see the full error message
      options.onStartUpload();
    }

    const board = this.getCard()?.getBoard();
    const upload =
      files.length > 0
        ? _.any(files, (file) => !Auth.me().canUploadAttachment(file, board))
          ? Promise.reject(FileTooLarge())
          : Promise.resolve(files).each((file, index) => {
              // There may be an @options.defaultName, but we don't want to use
              // it because we want to keep the file extension
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              const name = file.name || pastedFileName();
              return ninvoke(this.getCard(), 'upload', file, name, {
                numOfFiles: files.length,
                fileIdx: index + 1,
                traceId,
              }).then(
                (response) => {
                  if (traceId) {
                    Analytics.sendTrackEvent({
                      source,
                      action: 'uploaded',
                      actionSubject: 'attachment',
                      actionSubjectId: 'fileAttachment',
                      attributes: {
                        taskId: traceId,
                      },
                    });

                    // @ts-expect-error TS(2345): Argument of type '{ source: string; taskName: stri... Remove this comment to see the full error message
                    Analytics.taskSucceeded(analyticsPayload);
                  }

                  return this.trigger('attach', {
                    // @ts-expect-error TS(2571): Object is of type 'unknown'.
                    mimeType: response.mimeType,
                    name: this.options.defaultName || name,
                    // @ts-expect-error TS(2571): Object is of type 'unknown'.
                    url: response.url,
                  });
                },
                (err) => {
                  if (traceId) {
                    // @ts-expect-error TS(2339): Property 'error' does not exist on type '{ source:... Remove this comment to see the full error message
                    analyticsPayload.error = err;
                    // @ts-expect-error TS(2345): Argument of type '{ source: string; taskName: stri... Remove this comment to see the full error message
                    Analytics.taskFailed(analyticsPayload);
                  }

                  return Promise.reject(err);
                },
              );
            })
        : // Doesn't support the file API, use form based upload
          ninvoke(Util, 'uploadFile', Auth.myToken(), $input);

    return upload
      .then(function () {
        Analytics.sendOperationalEvent({
          action: 'completed',
          actionSubject: 'upload',
          source: 'cardAttachmentPickerInlineDialog',
        });
        showFlag({
          title: l('alerts.finished uploading files'),
          icon: <TacoIcon />,
          id: 'AjaxQueueUpload',
          msTimeout: 2000,
        });
        PopOver.hide();
        if (options.onFinishUpload) {
          // @ts-expect-error TS(2339): Property 'onFinishUpload' does not exist on type '... Remove this comment to see the full error message
          return options.onFinishUpload();
        }
      })
      .catch(FileTooLarge, function () {
        $tooLarge.show();
        if (options.onFinishUpload) {
          // @ts-expect-error TS(2339): Property 'onFinishUpload' does not exist on type '... Remove this comment to see the full error message
          options.onFinishUpload();
        }
        return Analytics.sendOperationalEvent({
          action: 'errored',
          actionSubject: 'upload',
          source: 'cardAttachmentPickerInlineDialog',
          attributes: {
            reason: 'file too large',
          },
        });
      })
      .catch(LimitExceeded, () => {
        this.render();
        return Analytics.sendOperationalEvent({
          action: 'errored',
          actionSubject: 'upload',
          source: 'cardAttachmentPickerInlineDialog',
          attributes: {
            reason: 'limit exceeded',
          },
        });
      })
      .catch(TypeRestricted, () => {
        PopOver.hide();
        if (options.onFinishUpload) {
          // @ts-expect-error TS(2339): Property 'onFinishUpload' does not exist on type '... Remove this comment to see the full error message
          options.onFinishUpload();
        }
        Alerts.show(
          'attachment upload restricted',
          'error',
          'attachment',
          5000,
        );
        return Analytics.sendOperationalEvent({
          action: 'errored',
          actionSubject: 'upload',
          source: 'cardAttachmentPickerInlineDialog',
          attributes: {
            reason: 'restricted by enterprise',
          },
        });
      })
      .catch(ApiError.NoResponse, () => {
        // There was a network error
        PopOver.hide();
        // @ts-expect-error TS(2339): Property 'onFinishUpload' does not exist on type '... Remove this comment to see the full error message
        options.onFinishUpload?.();
        Alerts.show('unable to upload file', 'error', 'upload', 5000);
        return Analytics.sendOperationalEvent({
          action: 'errored',
          actionSubject: 'upload',
          source: 'cardAttachmentPickerInlineDialog',
          attributes: {
            reason: 'other',
          },
        });
      })
      .done();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _loadOnce(scriptUrl: any, next: any) {
    // @ts-expect-error TS(2339): Property '_loadedScripts' does not exist on type '... Remove this comment to see the full error message
    if (window._loadedScripts == null) {
      // @ts-expect-error TS(2339): Property '_loadedScripts' does not exist on type '... Remove this comment to see the full error message
      window._loadedScripts = {};
    }
    // @ts-expect-error TS(2339): Property '_loadedScripts' does not exist on type '... Remove this comment to see the full error message
    if (window._loadedScripts[scriptUrl]) {
      return next();
    }

    return loadScript(scriptUrl).then(() => {
      // @ts-expect-error TS(2339): Property '_loadedScripts' does not exist on type '... Remove this comment to see the full error message
      window._loadedScripts[scriptUrl] = true;
      return next();
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attachLinks(type: any, objs: any, normalize: any) {
    const traceId = Analytics.startTask({
      source: 'cardAttachmentPickerInlineDialog',
      taskName: 'create-attachment/link',
    });
    if (!objs) {
      return;
    }
    $('.js-limit-exceeded', this.$el).toggleClass('hide', true);
    // @ts-expect-error TS(2339): Property 'onStartUpload' does not exist on type '{... Remove this comment to see the full error message
    this.options.onStartUpload?.(this.model, type);

    PopOver.pushView({
      view: UploadingLinkView,
    });
    return (
      Promise.resolve(objs)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .call('map', normalize != null ? normalize : (o: any) => o)
        .each((file) => {
          const data = _.pick(file, 'url', 'mimeType', 'name');
          this.trigger('attach', data);
          return Promise.fromNode((next) =>
            this.getCard().uploadUrl(data, next),
          ).then((response) => {
            return Analytics.sendOperationalEvent({
              action: 'completed',
              actionSubject: 'upload',
              source: 'cardAttachmentPickerInlineDialog',
              attributes: {
                type,
              },
            });
          });
        })
        .then(() => {
          Analytics.taskSucceeded({
            source: 'cardAttachmentPickerInlineDialog',
            taskName: 'create-attachment/link',
            traceId,
          });
          return PopOver.hide();
        })
        .catch(LimitExceeded, () => {
          PopOver.popView(); // Pop the `UploadingLinkView`
          this.render(); // Re-render to show the limit exceeded error
          return Analytics.sendOperationalEvent({
            action: 'errored',
            actionSubject: 'upload',
            source: 'cardAttachmentPickerInlineDialog',
            attributes: {
              reason: 'limit exceeded',
            },
          });
        })
        .catch(TypeRestricted, () => {
          Alerts.show('link type restricted', 'error', 'attachment', 5000);
          Analytics.sendOperationalEvent({
            action: 'errored',
            actionSubject: 'upload',
            source: 'cardAttachmentPickerInlineDialog',
            attributes: {
              reason: 'type restricted',
            },
          });
          return PopOver.hide();
        })
        .finally(() => {
          // @ts-expect-error TS(2339): Property 'onFinishUpload' does not exist on type '... Remove this comment to see the full error message
          return this.options.onFinishUpload?.(this.model, type);
        })
        .done()
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openGoogleDriveFilePicker(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedLinkEvent({
      linkName: 'attachFromGoogleDriveLink',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });

    return ninvoke(window.gapi, 'load', 'picker')
      .then(function () {
        // Google will pop up a window but it should automatically close for existing users
        const refresh = GoogleApi.validToken();
        return ninvoke(GoogleApi, 'authorize', refresh);
      })
      .then((oauthToken) => {
        // Use a docs view that shows folders
        // @ts-expect-error TS(2339): Property 'picker' does not exist on type 'typeof g... Remove this comment to see the full error message
        const docsView = new window.google.picker.DocsView();
        docsView.setIncludeFolders(true);

        // @ts-expect-error TS(2339): Property 'picker' does not exist on type 'typeof g... Remove this comment to see the full error message
        const teamDrivesView = new window.google.picker.DocsView();
        teamDrivesView.setIncludeFolders(true);
        teamDrivesView.setSelectFolderEnabled(true);
        teamDrivesView.setEnableTeamDrives(true);

        // @ts-expect-error TS(2339): Property 'picker' does not exist on type 'typeof g... Remove this comment to see the full error message
        const picker = new window.google.picker.PickerBuilder()
          // @ts-expect-error TS(2339): Property 'picker' does not exist on type 'typeof g... Remove this comment to see the full error message
          .enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED)
          // @ts-expect-error TS(2339): Property 'picker' does not exist on type 'typeof g... Remove this comment to see the full error message
          .enableFeature(window.google.picker.Feature.SUPPORT_TEAM_DRIVES)
          .addView(docsView)
          .addView(teamDrivesView)
          .setOAuthToken(oauthToken)
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .setCallback((data: any) => {
            // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
            return this.attachLinks('Google drive file', data.docs);
          })
          .build();

        picker.setVisible(true);
        // Fix ridiculous google drive bug
        return $('iframe.picker-frame[src*=authserviceid]').attr(
          'src',
          function () {
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            return $(this)
              .attr('src')
              .replace(/authserviceid/g, 'fixgoogle');
          },
        );
      })
      .catch((err) => {
        switch (err.message) {
          case 'popup_closed_by_user':
            // The user closed the popup before finishing the sign in flow.
            break;
          case 'access_denied':
            // The user denied the permission to the scopes required.
            break;
          case 'popup_blocked_by_browser':
            // The browser's popup blocker prevented opening the singin window
            // On first click of "Google Drive", Safari and Firefox throw this error. Second click opens popup
            showFlag({
              // @ts-expect-error TS(2322): Type '"googleSignInError"' is not assignable to ty... Remove this comment to see the full error message
              id: 'googleSignInError',
              title: format('google-sign-in-error'),
              description: (
                <>
                  <div>{format('try-again-or-support')}</div>
                  <div>
                    <a
                      href="https://help.trello.com/article/1331-trouble-attaching-from-google-drive"
                      target="_blank"
                    >
                      {format('visit-support')} <ExternalLinkIcon />
                    </a>
                  </div>
                </>
              ),
              appearance: 'error',
            });
            break;
          case 'idpiframe_initialization_failed':
            // When not currently signed in to a Google account, Chrome throws this error everytime and will not open the sign in window
            showFlag({
              // @ts-expect-error TS(2322): Type '"googleSignInError"' is not assignable to ty... Remove this comment to see the full error message
              id: 'googleSignInError',
              title: format('google-sign-in-error'),
              description: (
                <>
                  <div>{format('try-again-or-support')}</div>
                  <div>
                    <a
                      href="https://help.trello.com/article/1331-trouble-attaching-from-google-drive"
                      target="_blank"
                    >
                      {format('visit-support')} <ExternalLinkIcon />
                    </a>
                  </div>
                </>
              ),
              appearance: 'error',
            });
            break;
          default:
            throw err;
        }
      })
      .done();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openDropboxFilePicker(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedLinkEvent({
      linkName: 'attachFromDropboxLink',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });

    this._loadOnce(this._scripts.dropbox, () => {
      // @ts-expect-error TS(2339): Property 'Dropbox' does not exist on type 'Window ... Remove this comment to see the full error message
      window.Dropbox.init({ appKey: dropboxClientAppKey });
      window.Dropbox.choose({
        // @ts-expect-error TS(2345): Argument of type '{ linkType: string; iframe: ... Remove this comment to see the full error message
        linkType: 'preview',
        iframe: true,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        success: (files: any) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return this.attachLinks('Dropbox file', files, (file: any) => ({
            url: file.link,
            name: file.name,
          }));
        },
      });

      // The overlay that dropbox creates isn't scrollable, so if your window
      // isn't very tall you can't click the cancel button.  This hack fixes
      // this situation by finding the chooser iframe and making the parent
      // scrollable
      $('iframe[src^="https://www.dropbox.com/chooser"]')
        .parent()
        .css('overflow', 'auto');
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openOneDriveFilePicker(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedLinkEvent({
      linkName: 'attachFromOneDriveLink',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });

    this._loadOnce(this._scripts.oneDrive, () => {
      Promise.try(
        () =>
          new Promise(function (resolve, reject) {
            // @ts-expect-error TS(2339): Property 'OneDrive' does not exist on type 'Window... Remove this comment to see the full error message
            const { OneDrive } = window;
            return OneDrive.open({
              clientId: oneDriveClientId,
              action: 'share',
              multiSelect: true,
              // If this is false, it takes over the whole window … not an overlay
              openInNewWindow: true,
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              success(response: any) {
                return resolve(response.value);
              },
              cancel() {
                return resolve([]);
              },
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              error(err: any) {
                return reject(err);
              },
              advanced: {
                redirectUri: `${siteDomain}/onedrive_callback_7.html`,
              },
            });
          }),
      )
        .then((files) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return this.attachLinks('OneDrive file', files, (file: any) => ({
            url: file.webUrl,
            name: file.name,
          }));
        })
        .done();
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openBoxFilePicker(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedLinkEvent({
      linkName: 'attachFromBoxLink',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });

    return this._loadOnce(this._scripts.box, () => {
      // @ts-expect-error TS(2551): Property 'BoxSelect' does not exist on type 'Windo... Remove this comment to see the full error message
      const boxSelect = new window.BoxSelect({
        clientId: boxClientId,
        linkType: 'shared',
        multiselect: true,
      });

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const boxSuccess = (files: any) => {
        boxSelect.unregister(boxSelect.SUCCESS_EVENT_TYPE, boxSuccess);
        // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
        return this.attachLinks('Box file', files);
      };

      boxSelect.success(boxSuccess);

      return boxSelect.launchPopup();
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keydown(e: any) {
    if (isSubmitEvent(e)) {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      return this.addUrl();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addUrl(e: any) {
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    let urls = $('.js-attachment-url', this.$el).val().split(/\s+/);
    let name = $('.js-attachment-name', this.$el).val();
    // @ts-expect-error TS(2345): Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
    if (!/\S/.test(name)) {
      name = undefined;
    }

    Analytics.sendClickedButtonEvent({
      buttonName: 'attachLinkButton',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });

    // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
    urls = _.filter(urls, (url) => /\S/.test(url));

    if (!_.isEmpty(urls) && urls.length < 10) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.attachLinks('link', urls, (url: any) => ({
        url,
        name,
      }));
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attachCard(e: any) {
    Analytics.sendClickedLinkEvent({
      linkName: 'attachFromTrelloLink',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });

    const trelloCompleterView = new TrelloCompleterView({
      model: this.model,
      card: this.model,
      button: true,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onStartUpload: (item: any) => {
        let url;
        if (item instanceof Card) {
          url = item.get('url');
          // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
          return this.attachLinks('card', [{ url }]);
        } else if (item instanceof Board) {
          url = item.get('url');
          // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
          return this.attachLinks('board', [{ url }]);
        }
      },
    });

    return PopOver.pushView({
      view: trelloCompleterView,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toggleAttachmentNameInput(e: any) {
    const url = $(e.currentTarget).val();
    const { type } = parseTrelloUrl(url);
    const isTrelloAttachment = ['board', 'card'].includes(type);
    // @ts-expect-error TS(2345): Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
    const isEmpty = !/\S/.test(url);
    return $('.js-name-link', this.$el).toggleClass(
      'hide',
      isTrelloAttachment || isEmpty,
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showRestrictedTooltip(e: any) {
    const $el = $(e.target, this.$el);
    return Tooltip.show(
      t.l('attachment-type-restricted'),
      $el,
      false,
      Tooltip.STYLE.MENU,
    );
  }

  hideRestrictedTooltip() {
    return Tooltip.hide();
  }
}

AttachmentTypePickerView.initClass();
export { AttachmentTypePickerView };
